<template>
    <div id="ods-card">
        <div class="project-add-banner">
            <div class="ods-img">
                <img :src="`${imgBase}${imgName}.png`" alt="ods" width="200px" height="275px">
            </div>
            <div class="content">
                <h4 class="bold mb-0" :style="`color: ${color} !important;`">{{ ods }}</h4>
                <h3 class="font-weight-100">
                    {{ title }} <br>
                    <span class="bold">Capital movilizado: {{ capital }}.</span>
                </h3>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "OdsCard",
        props: ["color", "imgName", "ods", "title", "capital"],
        data() {
            return  {
                imgBase: "https://cdn.redgirasol.com/nuevo_portal/icons/ods/icon-ods-"
            }
        }
    }
</script>

<style>
.ods-img {
    margin-left: 2rem !important;
    margin-right: 3rem !important;
}

.project-add-banner {
    background-color: var(--color-gray-6);
    margin-bottom: 3rem !important;
    border-radius: 50px !important;
}

.bolder {
    font-weight: 700 !important;
}
</style>